var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArchiveRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2C0 1.6915 9.53674e-08 0.937264 0.468624 0.468624C0.937264 9.53674e-08 1.6915 0 3.2 0H28.8C30.3085 0 31.0627 9.53674e-08 31.5314 0.468624C32 0.937264 32 1.6915 32 3.2C32 4.7085 32 5.46274 31.5314 5.93138C31.0627 6.4 30.3085 6.4 28.8 6.4H3.2C1.6915 6.4 0.937264 6.4 0.468624 5.93138C9.53674e-08 5.46274 0 4.7085 0 3.2Z",
    fill: "#E4151B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9101 8.80303C29.1361 8.80312 29.3681 8.80322 29.5999 8.80002V16.0019C29.5999 22.0349 29.5999 25.0516 27.7253 26.9257C25.8927 28.7581 22.9682 28.7991 17.1999 28.8V17.5287L19.9079 20.5372C20.3513 21.0298 21.11 21.0698 21.6026 20.6265C22.0953 20.1832 22.1353 19.4246 21.6919 18.932L16.8919 13.5995C16.6642 13.3466 16.3401 13.2023 15.9999 13.2023C15.6597 13.2023 15.3356 13.3466 15.1079 13.5995L10.308 18.932C9.86461 19.4246 9.90454 20.1832 10.3971 20.6265C10.8898 21.0698 11.6485 21.0298 12.0919 20.5372L14.7999 17.5287V28.8C9.03166 28.7991 6.10705 28.7581 4.27441 26.9257C2.3999 25.0516 2.3999 22.0349 2.3999 16.0019V8.80002C2.63171 8.80322 2.86389 8.80312 3.08973 8.80303H28.9101Z",
    fill: "#E4151B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArchiveRed);
export default __webpack_public_path__ + "static/media/ic-archive-red.089181322e00ed172f0ada9fc21ef69b.svg";
export { ForwardRef as ReactComponent };